import { render, staticRenderFns } from "./ContactDetailsAvatar.vue?vue&type=template&id=cc3f30be&scoped=true&"
import script from "./ContactDetailsAvatar.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsAvatar.vue?vue&type=style&index=0&id=cc3f30be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3f30be",
  null
  
)

export default component.exports